import { useTranslations } from '@vocab/react';
import { Box, TooltipRenderer, Text, Badge } from 'braid-design-system';

import translations from './.vocab';

export const MaybeApproachableBadge = () => {
  const { t } = useTranslations(translations);

  return (
    <TooltipRenderer
      data-testid="may-be-approachable-tooltip"
      id="may-be-approachable-tooltip"
      tooltip={<Text>{t('SEEK_PREDICTIVE_TECH')}</Text>}
    >
      {({ triggerProps }) => (
        <Box {...triggerProps}>
          <Badge tone="info">{t('MAY_BE_APPROACHABLE')}</Badge>
        </Box>
      )}
    </TooltipRenderer>
  );
};
